import { useContext } from "react";

import { AudienceContext, AudienceContextData } from "../contexts/Audience";

export function useAudience(): AudienceContextData {
  const context = useContext(AudienceContext);

  if (!context) {
    throw new Error("useAudience must be used within an AuthProvider");
  }

  return context;
}
